module.exports = __webpack_public_path__ + "static/media/ticket_sale.36de1854.jpg";